import { Component } from '@angular/core';
import { Auth, signInWithPopup, GoogleAuthProvider } from '@angular/fire/auth';
import { ActivatedRoute } from '@angular/router';
import { Functions, httpsCallable } from '@angular/fire/functions';

@Component({
  selector: 'app-login',
  imports: [],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login {

  constructor(
    private route: ActivatedRoute,
    private afAuth: Auth,
    private functions: Functions
  ) {
  }

  async loginWithGoogle() {
    const userCred = await signInWithPopup(this.afAuth, new GoogleAuthProvider());
    const idToken = await userCred.user.getIdToken(false);

    const apiCall = httpsCallable(this.functions, 'retrieveOTC');
    const { data } = await apiCall({ idToken });
    const { otcToken } = data as any;

    const returnUrl = this.route.snapshot.queryParams['returnUrl'] ?? 'https://divezone.app';
    const state = this.route.snapshot.queryParams['state'] ?? '';
    const url = new URL(returnUrl);
    url.hash = `otcToken=${encodeURIComponent(otcToken)}&state=${encodeURIComponent(state)}`
    window.location.assign(url.toString());
  }


}
